import { render, staticRenderFns } from "./receipt.vue?vue&type=template&id=00acc87b&scoped=true"
import script from "./receipt.vue?vue&type=script&lang=js"
export * from "./receipt.vue?vue&type=script&lang=js"
import style0 from "./receipt.vue?vue&type=style&index=0&id=00acc87b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00acc87b",
  null
  
)

export default component.exports